<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :lock-scroll="false"
    :destroy-on-close="true"
    top="8vh"
    :show-close="false"
    center
  >
    <dialog-header
      slot="title"
      :title="!isEdit?$t('banner.addbanner'):$t('banner.editbanner')"
      :icon="!isEdit?'icon-dialog-add': 'icon-dialog-update'"
      @close="closeDialog"
    />
    <vue-linetitle>
      <el-form
        ref="form"
        :rules="rulesCenter"
        :model="formInfo"
        :label-position="'right'"
        :label-width="$t('shop.formLeftWidth')"
      >
            <el-form-item :label="$t('banner.selectImg')+'：'" prop="bannerImg">
            <div style="min-height: 156px">
            <el-upload
              action="/api/banner/uploadImg"
              list-type="picture-card"
              name="file"
              class="logoImg"
              accept=".jpg,.jpeg,.png,.gif,.bmp,.svg,.JPG,.JPEG,.PBG,.GIF,.BMP,.SVG"
              :headers="{Authorization: token}"
              :auto-upload="true"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              :on-success="handleSuccess"
              :file-list="fileList_logo"
              :on-change="handleChange"
              :on-error="handleError"
              :before-upload="beforeAvatarUpload"
            >
              <div class="el-upload__text">{{$t('banner.selectImg')}}</div>
            
            </el-upload>
            </div> 
            <el-dialog :visible.sync="logoDialogVisible" append-to-body>
              <img width="100%" :src="logoUrl" alt="">
            </el-dialog>
            </el-form-item>
            <el-form-item :label="$t('banner.linkPath')+'：'" prop="linkPath">
               <el-input v-model="formInfo.linkPath" clearable :placeholder="$t('banner.linkPath')"/>
             </el-form-item>
             <el-form-item :label="$t('public.description')+'：'" prop="bannerDescribe">
               <el-input
                v-model="formInfo.bannerDescribe"
                :rows="3"
                :autosize="{ minRows: 3, maxRows: 3}"
                resize="none"
                :placeholder="$t('public.description')"
                type="textarea"
                :maxlength="500"
                :show-word-limit="true"
                 />
             </el-form-item>

      </el-form>
    </vue-linetitle>
    <span slot="footer" class="dialog-footer">
      <el-button v-waves class="dialog-cancel" type="primary" @click="handleCancel">{{ $t('public.cancel') }}</el-button>
      <el-button v-waves type="primary" @click="handleSubmit">{{ $t('public.define') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 混入
import { partialForm } from '@/mixins/partialForm'
// request
import { createBanner,updateBanner } from '@/api/userCenter/banner'
export default {
  name: 'AddUpdateDialog',
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    token() {
      return this.$store.getters.token
    },
  },
  data() {
    // 图片
    const validateBannerImg = (rule, value, cb) => {
      if(!this.formInfo.bannerImg) return cb(new Error(this.$t('banner.error1')))
    }
    // 描述
    const validateBannerDescribe = (rule, value, cb) => {
      if(!value) return cb(new Error(this.$t('banner.error2')))
    }
    return {
      formInfo: {},
      rulesCenter: {
        bannerImg: [
          { required: true, trigger: ['blur','change'], validator: validateBannerImg }
        ],
        bannerDescribe: [
          { trigger: ['blur','change'], validator: validateBannerDescribe }
        ]
      },
      fileList_logo:[],
      fileList_img:[],
      imageId:'',
      logoDialogVisible:false,
      imgDialogVisible:false,
      logoUrl:'',
      imgUrl:'',
    }
  },
  watch: {
    visibles(e1) {
      if (e1) {
        this.formInfo = { ...this.data }
        if(this.data.bannerImg){
          this.fileList_logo.push({
            url: this.data.bannerImg
          })
          this.$nextTick(() => {
            document.querySelector('.logoImg>.el-upload').style.display = 'none'
          })
        }
        
      }
    }
  },
  created() {
  },
  methods: {
    // 关闭
    closeDialog() {
      this.fileList_logo = []
      this.$emit('update:visibles', false)
    },
    // 取消
    handleCancel() {
      this.closeDialog()
    },
    //上传
    // eslint-disable-next-line no-unused-vars
    handleSuccess(res, file, fileList, parentClassName) {
      
      if (res.code === 0) {
        this.imageId = res.data.imageId
        // this.formInfo.linkPath = file.name
        this.formInfo.bannerImg = res.data.imageId
      } else {
        this.fileList = []
        this.$message.error(this.$t('public.uploadImageFailed'))
        document.querySelector('.logoImg>.el-upload').style.display = 'inline-block'
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleChange(file, fileList, parentClassName) {
      document.querySelector('.logoImg>.el-upload').style.display = 'none'
    },
    // eslint-disable-next-line no-unused-vars
    handleRemove(file, fileList, parentClassName) {
      // this.imageId = ''
      document.querySelector('.logoImg>.el-upload').style.display = 'inline-block'
      this.formInfo.bannerImg = ''
      // this.formInfo.linkPath = ''
    },
    // eslint-disable-next-line no-unused-vars
    handleError(err, file, fileList, parentClassName) {
      document.querySelector('.logoImg>.el-upload').style.display = 'inline-block'
    },
    // eslint-disable-next-line no-unused-vars
    handlePreview(file,urlName) {
      this.logoUrl = file.url
      this.logoDialogVisible = true
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg'
      const isPng = file.type === 'image/png'
      const issvg = file.type === 'image/svg+xml'
      const isbmp = file.type === 'image/bmp'
      const isgif = file.type === 'image/gif'
      if (!isJPG && !isPng && !issvg && !isbmp && !isgif) {
        this.$message.error(this.$t('shop.photo'))
        return false
      }
      return true
    },
    // 提交
    handleSubmit() {
      const formCheck = this.checkForm({
        formName: 'form',
        formList: ['bannerImg', 'bannerDescribe']
      })
      if (!formCheck) {
        return
      }
      const { bannerImg,bannerDescribe,linkPath,bannerId,bannerImgId } = this.formInfo
      const postData = {
        bannerImg,
        bannerDescribe,
        linkPath
      }
      if (!this.isEdit) {
        this._createBanner(postData)
      } else {
        postData.bannerId = bannerId
        postData.bannerImg = bannerImgId
        this._updateBanner(postData)
      }
    },
    // 新增
    _createBanner(postData) {
      createBanner(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    _updateBanner(postData) {
      updateBanner(postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.updateSuccess'),
            duration: 2 * 1000
          })
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.logoImg{
  margin: 0;
}

</style>
